module.exports = __webpack_public_path__ + "img/automation-icon-dark.cc4276bc.svg";